export default __webpack_public_path__ + "static/media/527.32c70e84.jpg";